import { useEffect, useState } from "react";
import "./Esanad.css";
import DynamicPdfCard from "../../include/DynamicPdfCard";
import DynamicBanner from "../../include/DynamicBanner";
import api from "../../../../api";

const Esanad = () => {
  const [banner, setBanner] = useState({ title: "", images: [],
  mobile_images: [], });
  const [cardData, setCardData] = useState({ heading: "", images: [], documents: [] });
  const [loading, setLoading] = useState(true);
const toArray = (val) => {
  if (!val) return [];
  if (Array.isArray(val)) return val;
  if (typeof val === "object") return Object.values(val);
  return [val];
};

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await api.get("/api/sitepages/about-us/esanad");
        const data = res.data || {};

        // Normalize banner
        const bannerData = data.banner_data || {};
       setBanner({
  title: bannerData.title || "",
  images: toArray(bannerData.images),
  mobile_images: toArray(bannerData.mobile_images),
});


        const cd = data.card_data || {};
        setCardData({
          heading: cd.heading || "",
          images: cd.images || [],
          documents: cd.documents || [],
        });
      } catch (err) {
        console.error("Error loading E-Sanad:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <div className="container py-5 text-center">Loading...</div>;

  return (
    <>
      <section className="e-sanad-page">

<DynamicBanner
  title={banner.title}
  bgImage={banner.images}
  bgImageMobile={banner.mobile_images}
/>
      
        <DynamicPdfCard
          heading={cardData.heading}
          images={cardData.images}
          documents={cardData.documents}
        />

      </section>
    </>
  );
};

export default Esanad;
